import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-chalk" data-id="element-0" data-mp="2wifgbev2vaz8">
      <MetaPixel data-id="element-1" data-mp="28ufo0ai4bcij" />
      <CountdownBar data-id="element-2" data-mp="28tw4wqgqei2x" />
      <main data-id="element-3" data-mp="28te37ebavbnm">
        <Hero data-id="element-4" data-mp="28sutulzptvl7" />
        <StatsBar data-id="element-5" data-mp="28sl0cofgp6ar" />
        <Difference data-id="element-6" data-mp="23vciyq2516ak" />
        <Recognize data-id="element-7" data-mp="23vunsb2v8su3" />
        <WhatsInside data-id="element-8" data-mp="23u9v6r043jyv" />
        <InstantAccess data-id="element-9" data-mp="23ut9lxqjzq85" />
        <Bonuses data-id="element-10" data-mp="23ti7018ugoim" />
        <Offer data-id="element-11" data-mp="3ik7eyd5x05p2" />
        <Guarantee data-id="element-12" data-mp="3ikr0e3urxc7u" />
        <Testimonials data-id="element-13" data-mp="3ij668fcdfvai" />
        <Faq data-id="element-14" data-mp="3ihv1odb3qjic" />
      </main>
      <Footer data-id="element-15" data-mp="3mlj6wpc9h30f" />
    </div>;
}